import React from 'react';
import { Footer } from '../Common/Footer';
import { SideBar } from '../Common/SideBar';
import Points from '../../Models/Points';
import { Header } from '../Common';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input } from 'reactstrap';
import SimpleReactValidator from 'simple-react-validator';
import { ToastContainer, toast } from "react-toastify";
class MyPoints extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 2) {
            alert('ログインしてください')
            window.location.href = '/login/seller';
        };
        var retrievedObject = window.localStorage.getItem('info');
        var logged_user = JSON.parse(retrievedObject);
        this.state = {
            _id: false,
            modal: false,
            nestedModal: false,
            closeAll: false,
            points: [],
            status: '',
            com_point: '',
            month_point: '',
            ammount: '',
            rem_point: '',
            logged_user_id: '',
            history: ''
        };
        this.validator = new SimpleReactValidator({ autoForceUpdate: this });
        this.toggle = this.toggle.bind(this);
        this.toggleNested = this.toggleNested.bind(this);
        this.toggleAll = this.toggleAll.bind(this);
        this.state.logged_user_id = logged_user.id;
        this.getMyPoints();
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    Notify(a) {
        toast(a, {
            position: "top-center"
        });
    }
    getMyPoints() {
        Points.getPoints(this.state.logged_user_id).then(res => {
            if (res.data.status === 200) {
                this.setState({ points: res.data.payload })
                this.setState({ com_point: parseInt(this.state.points.total_amount) })
                this.setState({ month_point: parseInt(res.data.last) })
                this.setState({ rem_point: parseInt(this.state.points.remaining_amount) })
            } else {
                this.setState({ com_point: 0 })
                this.setState({ month_point: 0 })
                this.setState({ rem_point: 0 })
            }

        })
        Points.getHistory(this.state.logged_user_id).then(res => {
            if (res.data.status === 200) {
                this.setState({ history: res.data.history })
            }
        })
    }

    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    toggle() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }

    toggleNested() {
        this.setState({
            nestedModal: !this.state.nestedModal,
            closeAll: false
        });
    }

    toggleAll() {
        this.setState({
            nestedModal: !this.state.nestedModal,
            closeAll: true
        });
    }

    // errorMessage() {
    //     return (
    //         <div>
    //             <span style={{ color: "red", fontSize: '12px' }}>Your amount must be between {this.state.rem_point} 円.</span> 
    //         </div>
    //     )
    // }
    check(e) {
        e.preventDefault();
        var f = 0;
        Points.getLegality(this.state.logged_user_id).then(res => {
            console.log(res.data.status)
            if(res.data.status == 200){
                f = 0;
            } else {
                f = 1;
            }
            if (f === 1) {
                this.Notify('プロファイル編集から全ての情報を入れてから振込申請をしてください')
            } else if (this.state.rem_point < this.state.ammount) {
                this.Notify(`申請した金額は ${this.state.rem_point}円 以内にしてください。`)
            } else if (this.state.ammount < 3000) {
                alert('3000円以上から振込みを申し込むことが可能')
                this.Notify('3000円以上から振込みを申し込むことが可能')
            } else {
                this.toggleNested();
            }
        })
    }

    handleSubmit(e) {
        e.preventDefault();
        var x = JSON.parse(localStorage.getItem('info'))
        if (this.state.rem_point < this.state.ammount) {
            alert(`申請した金額は ${this.state.rem_point}円 以内にしてください。`)
        } else if (this.state.ammount < 3000) {
            alert('3000円以上から振込みを申し込むことが可能')
        } else {
            let data = {
                id: x.id,
                amount: this.state.ammount
            }
            Points.WithdrawPoints(data).then(res => {
                if (res.data.message === 'Success') {
                    alert('振込申請が送信されました')
                    this.toggleAll.bind(this)
                    window.location.reload()
                }
            })
        }
    }

    withdrawPoints() {
        if (this.state.rem_point < 3000) {
            return (
                <div>
                    <Button color="" className="" style={{ color: '#444', cursor: 'pointer', height: '35px', border: "1px solid #ccc" }}>振込申請する</Button>
                </div>
            )
        } else {
            return (
                <Button color="" className="" onClick={this.toggle} style={{ color: '#444', cursor: 'pointer', height: '35px', border: "1px solid #ccc" }}>振込申請する</Button>
            )
        }
    }

    apply() {
        var p = this.state.rem_point
        return (
            <div className="">
                {this.withdrawPoints()}
                {/* <Button color="" className="" onClick={this.toggle} style={{ color: '#444', cursor: 'pointer', height: '35px', border: "1px solid #ccc" }}>振込申請する</Button> */}
                <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                    <ModalHeader toggle={this.toggle}>振込申請</ModalHeader>
                    <ModalBody>
                        <div className="container">
                            <Form onSubmit={this.handleSubmit.bind(this)}>
                                <FormGroup>
                                    <Label for="exampleEmail">金額</Label>
                                    <Input type="number" name="number" id="exampleEmail" value={this.state.ammount} onChange={this.updateValue.bind(this, 'ammount')} />
                                    {/* {this.errorMessage()} */}

                                </FormGroup>
                            </Form>
                        </div>
                        <ModalFooter>
                            <Button color="secondary" onClick={this.toggle}>キャンセル</Button>
                            <Button style={{ backgroundColor: "#7ea9e6", borderColor: "#6290d1" }} onClick={this.check.bind(this)}>確認する</Button>
                        </ModalFooter>
                        <Modal isOpen={this.state.nestedModal} toggle={this.toggleNested} onClosed={this.state.closeAll ? this.toggle : undefined}>
                            <ModalHeader>振込申請確認</ModalHeader>
                            <ModalBody><Label for="exampleEmail">申請した金額 </Label> {this.state.ammount} 円</ModalBody>
                            <ModalFooter>
                                <Button color="secondary" onClick={this.toggleNested}>修正する</Button>
                                <Button style={{ backgroundColor: "#7ea9e6", borderColor: "#6290d1" }} onClick={this.handleSubmit.bind(this)} >送信する</Button>{' '}
                            </ModalFooter>
                        </Modal>
                    </ModalBody>
                </Modal>
            </div>
        )
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //for mobile responsive
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-8">
                                <div className="mt-5 input_name big_font" style={{textAlign:'left', width: '100%',fontSize:'20px' }}>
                                    振込申請
                                </div>
                                <div style={{ border: "1px solid #bababa", paddingTop: "7%", paddingLeft: "2%", paddingRight: "2%" }}>
                                    <div className="center">
                                        売上金残高
                                    </div>
                                    <div className="center">
                                        <h3>{this.state.rem_point} P</h3>
                                    </div>
                                    <div>&nbsp;</div>
                                    <div className="center">{this.apply()}</div>
                                    <div>&nbsp;</div>
                                    <div className=" center">
                                        <div className="col-md-2"></div>
                                        <div className="" >
                                            <div className="col">
                                                <div className="col-md-6" style={{ textAlign: "center", padding: "3%" }}>
                                                    今月の累積売上<br />
                                                    <h4>{this.state.month_point} p</h4>
                                                </div>
                                                <div className="col-md-6" style={{ textAlign: "center", padding: "3%" }}>
                                                    累積売上<br />
                                                    <h4>{this.state.com_point} p</h4>
                                                </div>
                                            </div>
                                            <div>&nbsp;</div>
                                            <div className="font_12">
                                                ステータスが評価または入力されていない場合は、
                                                </div>
                                            <div className="font_12">
                                                売上に記録されます
                                            </div>
                                        </div>
                                        <div className="col-md-2"></div>
                                    </div>
                                    <div className="">
                                        <div style={{ fontSize: "20px", padding: "3%", borderBottom: "1px solid #ddd" }}>
                                            売上金の振替
                                                </div>
                                        <div>
                                            <span className="font_12">
                                                . 3000円以上から振込みを申し込むことができます。別途振込手数料として756円かかります
                                                    </span>
                                            <div>&nbsp;</div>
                                            <span className="font_12">
                                                . 振込の申請が同月の1日から31日に行われる場合は、翌々月5日に支払われます.（金融機関休業日の場合は翌営業日）
                                                    </span>
                                            <div>&nbsp;</div>
                                            <span className="font_12">
                                                . 代金の振込みを申請するには、会員情報と振込口座の登録が必要です。<br />
                                            </span>
                                            <div>&nbsp;</div>
                                        </div>
                                    </div>
                                </div>
                                <div>&nbsp;<br /></div>
                                <div style={{ height: "auto", border: "1px solid #bababa", padding: "3%" }}>
                                    <div style={{ width: "100%", textAlign: "center" }}>
                                        <span style={{ fontSize: "20px" }}><b>振込申請履歴</b></span>
                                    </div>
                                    <div>&nbsp;<br /></div>
                                    {/* <div>
                                        {(() => {
                                            if (this.state.history.length === 0) {
                                                return (
                                                    <div></div>
                                                )
                                            } else {
                                                return (
                                                    <div className="col-md-12 row" style={{ borderBottom: "1px solid #bababa", padding: "1%", fontSize: "13px" }}>
                                                        <div className="col-md-5" style={{ textAlign: "left" }}>
                                                            日付
                                                                </div>
                                                        <div className="col-md-4" style={{ textAlign: "left" }}>
                                                            金額
                                                                </div>
                                                        <div className="col-md-3" style={{ textAlign: "left" }}>
                                                            状況
                                                                </div>
                                                    </div>
                                                )
                                            }
                                        })()} 
                                    </div>*/}
                                    <div style={{ fontSize: "13px" }}>
                                        {(() => {
                                            if (this.state.history.length === 0) {
                                                return (
                                                    <div></div>
                                                )
                                            } else {
                                                return (
                                                    <div>
                                                        {this.state.history.map(group =>
                                                            <div className="p-2">
                                                                <div className="col-12" style={{ textAlign: "left" }}>
                                                                    req amount: {group.requested_amount} 円
                                                                </div>
                                                                <div className="col-12" style={{ textAlign: "left" }}>
                                                                    receivable amount: {group.requested_amount - 756} 円
                                                                </div>
                                                                <div className="row col-12">
                                                                    <div className="col-7" style={{ textAlign: "left" }}>
                                                                        {group.created_at}
                                                                    </div>
                                                                    <div className="col-5" style={{ textAlign: "left" }}>
                                                                        {(() => {
                                                                            if (group.request_status === 'PENDING') {
                                                                                return (
                                                                                    <span>申請中</span>
                                                                                )
                                                                            } else if (group.request_status === 'DEPOSITED') {
                                                                                return (
                                                                                    <span>完了</span>
                                                                                )
                                                                            } else {
                                                                                return (
                                                                                    <span>拒否</span>
                                                                                )
                                                                            }
                                                                        })()}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                )
                                            }
                                        })()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <ToastContainer />
                        <Footer />
                    </div>
                </div>
            )
        }
        else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <SideBar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className="mb-1 input_name big_font " style={{ width: '100%',textAlign:'left' }}>
                                            振込申請
                                    </div>
                                        <div style={{ border: "1px solid #bababa", paddingTop: "7%", paddingLeft: "2%", paddingRight: "2%" }}>
                                            <div className="center">
                                                売上金残高
                                        </div>
                                            <div className="center">
                                                <h3>{this.state.rem_point} P</h3>
                                            </div>
                                            <div>&nbsp;</div>
                                            {/* <div className="center">{this.preCheck.bind(this)}</div> */}
                                            <div className="center">{this.apply()}</div>
                                            <div>&nbsp;</div>
                                            <div className="row center">
                                                <div className="col-md-2"></div>
                                                <div className="col-md-8" style={{ borderTop: "1px solid #ddd" }}>
                                                    <div className="col-md-0 row">
                                                        <div className="col-md-6" style={{ borderRight: "1px solid #ddd", textAlign: "center", padding: "3%" }}>
                                                            今月の累積売上<br />
                                                            <h4>{this.state.month_point} p</h4>
                                                        </div>
                                                        <div className="col-md-6" style={{ textAlign: "center", padding: "3%" }}>
                                                            累積売上<br />
                                                            <h4>{this.state.com_point} p</h4>
                                                        </div>
                                                    </div>
                                                    <div>&nbsp;</div>
                                                    <div className="font_12">
                                                        ステータスが評価または入力されていない場合は、売上に記録されます
                                                    </div>
                                                </div>
                                                <div className="col-md-2"></div>
                                            </div>
                                            <div className="col-md-12">
                                                <div style={{ fontSize: "20px", padding: "1%", borderBottom: "1px solid #ddd" }}>
                                                    売上金の振替
                                            </div>
                                                <br />
                                                <div>
                                                    <span className="font_12">
                                                        . 3000円以上から振込みを申し込むことができます。別途振込手数料として756円かかります
                                                </span>
                                                    <div>&nbsp;</div>
                                                    <span className="font_12">
                                                        . 振込の申請が同月の1日から31日に行われる場合は、翌々月5日に支払われます.（金融機関休業日の場合は翌営業日）
                                                </span>
                                                    <div>&nbsp;</div>
                                                    <span className="font_12">
                                                        . 代金の振込みを申請するには、会員情報と振込口座の登録が必要です。<br />
                                                    </span>
                                                    <div>&nbsp;</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div>&nbsp;<br /></div>
                                        <div style={{ height: "auto", border: "1px solid #bababa", padding: "3%" }}>
                                            <div style={{ width: "100%", textAlign: "center" }}>
                                                <span style={{ fontSize: "24px" }}><b>振込申請履歴</b></span>
                                            </div>
                                            <div>&nbsp;<br /></div>
                                            <div>
                                                {(() => {
                                                    if (this.state.history.length === 0) {
                                                        return (
                                                            <div></div>
                                                        )
                                                    } else {
                                                        return (
                                                            <div className="col-md-12 row" style={{ borderBottom: "1px solid #bababa", padding: "1%", fontSize: "14px" }}>
                                                                <div className="col-md-4" style={{ textAlign: "left" }}>
                                                                    日付
                                                                </div>
                                                                <div className="col-md-3" style={{ textAlign: "left" }}>
                                                                    金額
                                                                </div>
                                                                <div className="col-md-3" style={{ textAlign: "left" }}>
                                                                    金額
                                                                </div>
                                                                <div className="col-md-2" style={{ textAlign: "left" }}>
                                                                    状況
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                })()}
                                            </div>
                                            <div>&nbsp;<br /></div>
                                            <div style={{ fontSize: "14px" }}>
                                                {(() => {
                                                    if (this.state.history.length === 0) {
                                                        return (
                                                            <div></div>
                                                        )
                                                    } else {
                                                        return (
                                                            <div>
                                                                {this.state.history.map(group =>
                                                                    <div className="col-md-12 row">
                                                                        <div className="col-md-4" style={{ textAlign: "left" }}>
                                                                            {group.created_at}
                                                                        </div>
                                                                        <div className="col-md-3" style={{ textAlign: "left" }}>
                                                                            {group.requested_amount} 円
                                                                        </div>
                                                                        <div className="col-md-3" style={{ textAlign: "left" }}>
                                                                            {group.requested_amount - 756} 円
                                                                        </div>
                                                                        <div className="col-md-2" style={{ textAlign: "left" }}>
                                                                            {(() => {
                                                                                if (group.request_status === 'PENDING') {
                                                                                    return (
                                                                                        <span>申請中</span>
                                                                                    )
                                                                                } else if (group.request_status === 'DEPOSITED') {
                                                                                    return (
                                                                                        <span>完了</span>
                                                                                    )
                                                                                } else {
                                                                                    return (
                                                                                        <span>拒否</span>
                                                                                    )
                                                                                }
                                                                            })()}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )
                                                    }
                                                })()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <ToastContainer />
                        <Footer />
                    </div>
                </div>
            )
        }
    }
}
export { MyPoints }